"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDivider = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DividerMixin = require("../../mixins/components/DividerMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledDivider = /*#__PURE__*/(0, _styledComponents.default)('div').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['orientation'])
}).withConfig({
  displayName: "StyledDivider",
  componentId: "c11n-8-107-0__sc-1r0esng-0"
})(["", ""], _DividerMixin.DividerMixin);
exports.StyledDivider = StyledDivider;